import { RECURRENCE_DAYS_LIMIT } from '../preventiveMaintenance/schedule/constants/recurentTypes';

export function validateLeadTimeForRecurrence(
  daysAhead: number,
  repeats: string
): boolean {
  const maxDays = RECURRENCE_DAYS_LIMIT[repeats];

  if (maxDays === undefined) {
    return true;
  }

  return daysAhead < maxDays;
}
